import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TokenSheet, DEFAULT_COIN, type Coin } from './TokenSheet';
import { SendScreen, type SendPrefill } from './SendScreen';
import { IncptSendScreen } from './IncptSendScreen';

type Step = 'coin' | 'send' | 'incpt';

/** Send flow: choose coin (action sheet) → send screen for that coin. `prefill`
 *  (set by a history Resend) skips the coin picker and prefills the send screen. */
export function SendFlow({
  onClose,
  coin: initialCoin,
  prefill,
}: {
  onClose: () => void;
  coin?: Coin;
  prefill?: SendPrefill;
}) {
  const { t } = useTranslation();
  const [step, setStep] = useState<Step>(initialCoin ? 'send' : 'coin');
  const [coin, setCoin] = useState<Coin>(initialCoin ?? DEFAULT_COIN);

  return (
    <>
      {step === 'send' && (
        <div className="push-enter fixed inset-0 z-50 overflow-y-auto bg-holo">
          <SendScreen coin={coin} onClose={onClose} prefill={prefill} />
        </div>
      )}

      {step === 'incpt' && (
        <div className="push-enter fixed inset-0 z-50 overflow-y-auto bg-holo">
          <IncptSendScreen onClose={onClose} />
        </div>
      )}

      <TokenSheet
        open={step === 'coin'}
        onClose={onClose}
        title={t('send.selectCoin')}
        uniqueOnly
        includeIncpt
        onSelectIncpt={() => setStep('incpt')}
        onSelect={(c) => {
          setCoin(c);
          setStep('send');
        }}
      />
    </>
  );
}
